export const completebookingType = {
  GET_COMPLETE_UNREPORTED_ORDERS: "GET_COMPLETE_UNREPORTED_ORDERS",
  GET_COMPLETE_REPORTED_ORDERS: "GET_COMPLETE_REPORTED_ORDERS",
  REQUEST_COMPLETE_REPORTING: "REQUEST_COMPLETE_REPORTING",
  REQUEST_COMPLETE_REPORTING_DONE: "REQUEST_COMPLETE_REPORTING_DONE",
  CHECK_COMPLETE_VIEW_EXIST: "CHECK_COMPLETE_VIEW_EXIST",
};
